import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { UtilitiesService } from '../../../../services/utilities.service';
import { ReceiptService } from '../../../../services/receipt.service';
import { TableService } from '../../../../services/table.service';
import { ToastrService } from 'ngx-toastr';//
import { DataTransferService } from '../../../../services/DataTransferService';
import { LocalApiConnectorService } from '../../../../services/local-api-connector.service';
import { LocationService } from '../../../../services/location.service';
import { SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND } from 'src/app/shared/constants';
import { TranslateService } from '@ngx-translate/core';
import { ModeComponent } from '../mode/mode.component';
import { ProductGroupComponent } from '../product-group/product-group.component';
import { ProductTypeComponent } from '../product-type/product-type.component';
import { ShipperComponent } from '../shipper/shipper.component';
import { PostalComponent } from '../postal/postal.component';
import { DuplicateShipmentService } from 'src/app/services/duplicate-shipment.service';
import { Subscription } from 'rxjs';
import { PostalCodeDataService } from 'src/app/services/postalcode-data-service';
import { log } from 'console';
import { promise } from 'protractor';




@Component({
  selector: 'create-edit-receipt',
  templateUrl: './create-edit-receipt.component.html',
  styleUrls: ['./create-edit-receipt.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})

export class CreateEditReceiptComponent implements OnInit, OnDestroy {
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  @ViewChild('receiptModeEle') receiptModeEle: ModeComponent;
  @ViewChild('receiptProductGroupEle') receiptProductGroupEle: ProductGroupComponent;
  private productTypeEle: ProductTypeComponent;

  @ViewChild('productTypeEle') set content(content: ProductTypeComponent) {
    console.log('not lodded')
     if(content) { // initially setter gets called with undefined
        console.log('lodded')
          this.productTypeEle = content;
     }
  }



  @ViewChild('shipperReceipt') shipperReceipt: ShipperComponent;
  @ViewChild('postalCode') postalCode: PostalComponent;
  ratedPriceRequest = {} as any;
  receipt = {} as receipt as any;
  generateInvoiceData = {} as any;
  shippmentContext = {} as IShippment;
  shippments = [] as any[];
  shipmentsByCurrency = {} as any;
  isReceiptAdditionalChargesNeeded: boolean = false;
  hasState = false as boolean;
  postCodeRequired = false as boolean;
  currentUserId: any;
  ListOfReceipts = [] as any[]
  showProductGroup = true;
  showProductType = true;
  showShipper = true;
  showConsigneeDetails = true;
  showServices = true;
  showCommodity = true;
  showShipmentItems = true;
  showCountry = true;
  showTheState = true;
  showCity = true;
  showPostalCode = true;
  currenceis = [] as any[]
  branchCurrencyCode: any;
  isReceiptLocked: boolean = true;
  change = false;
  showInboundAWB = true;
  showDropOffAWB = false;
  showCategory = true;
  MiscAWBDetails = true;
  // Test Adding new Packaging AWB
  showPackaging = false;
  packagingPrice: string;
  isRequiredShipmentNumberMisc: boolean = true;
  isRequiredCommentsMisc: boolean = true;
  receiptSubTypeIdMisc: number = 1;
  initalShipment = {} as any;
  resetAdditionalCharges: any;
  OutboundAdditionalCharges = [] as any[];
  tempDisable: boolean = false;
  locationSettings: any[] = JSON.parse(sessionStorage.getItem('branchSettings'));
  isMultiCurrenciesForInbound = false;
  duplicateShipmentSubscription: Subscription;
  branchCompanyCountryName = JSON.parse(sessionStorage.getItem("company")).BranchCompanyCountryName;
  selectedSize :boolean = false;

  enableShipper() {
    var s = '';
    this.data.currentProductTypeSource.subscribe(x => s = x);
    if (s == null || s == undefined || s == 'default message') {
      return this.receipt.productType != null;
    }
    else {
      if (this.hasState)
        return this.receipt.state != null;
      else
        return this.receipt.city != null;
    }
  }
  constructor(
    private cdRef: ChangeDetectorRef,
    private utilites: UtilitiesService,
    private receiptService: ReceiptService,
    private userContext: TableService,
    //private _scrollToService: ScrollToService,
    private toaster: ToastrService,
    private data: DataTransferService,
    private agent: LocalApiConnectorService,
    private locationService: LocationService,
    private translate: TranslateService,
    private dupShipmentService: DuplicateShipmentService,
    private postalDataService: PostalCodeDataService

  ) {
    this.countries = [{}];
    this.postalCodes = [{}];
    this.cities = [{}];
    this.states = [{}]
    this.commodities = [{}];
    this.productTypes = [{}];
    this.receipt.shipmentItems = null;
    this.receipt.additionlCharges = null;
  }
  modeSelected: boolean;
  productTypes: any[];
  shipperTypes: any[];
  shipperNationalities: any[];
  countries: any[];
  allCountriesData: any;
  postalCodes: any[];
  states = [] as any[];
  cities = [] as any[];
  commodities: any[];
  services: services[];
  userAccounts: any[];
  receiptSubTypes: any[];
  branch = JSON.parse(sessionStorage.getItem('branch')).branch.BranchCompanyCode;
  countryCode: any = JSON.parse(sessionStorage.getItem('company')).BranchCompanyCountryCode;;
  branchCountryCode = JSON.parse(sessionStorage.getItem('company')).BranchCompanyCountryCode;
  branchCompanyCode = JSON.parse(sessionStorage.getItem('company')).Branches[0].BranchCompanyCode;
  branchCompanyName = JSON.parse(sessionStorage.getItem('company')).Branches[0].BranchCompanyName;
  branchCity = JSON.parse(sessionStorage.getItem('branch')).branch.BranchCity;
  branchPostCode = JSON.parse(sessionStorage.getItem('branch')).branch.BranchPostCode;
  branchState = JSON.parse(sessionStorage.getItem('branch')).branch.BranchState;
  scanners: any = [];
  hasRTIShipment = false;
  RTIShipments = [] as any[];
  isInitial = false

  ngOnInit() {
    this.receiptService.loadDGSecureScript("");
    this.agent.getScanners((res) => {
      this.scanners = this.toArray(res);
    })
    
    this.utilites.getCountries((res) => {
      this.allCountriesData = res;
    }, (err) => { });
  }

  ngOnDestroy(): void {
    if(this.duplicateShipmentSubscription){
      this.duplicateShipmentSubscription.unsubscribe();
    }
  }

toArray(obj) {
    var arr = [];
    for (var x in obj) if (obj.hasOwnProperty(x)) {
      arr.push(obj[x]);
    }
    return arr;
  }

  showShippments() {
    this.isReceiptLocked = false;
  }
  onModeSelected(type) {
    this.change = false;
    this.enableSelectProductGroup(true);
    this.enableSelectInboundAWB(true);
    this.enableSelectCategory(true);
    this.enableSelectPackaging(true);
    this.receipt.mode = type;
    if (type.toLowerCase() == 'dropoff') {
      this.showDropOffAWB = true;
    }
    if (type.toLowerCase() == 'packaging') {
      this.showPackaging = true;
    }
    this.receipt.AWB = null;
    if (this.receipt.mode == "Misc") {
      this.receiptService.getReceiptSubTypes(3, (res) => {
        this.receiptSubTypes = res;
      }, (err) => {
      });
    }
  }


  allCountries
  invalidCountryMsg = ''
  invalidResolve = false;


  onProductGroupSelected(type) {
    this.enableSelectProductType(true);
    this.enableSelectCountry(true);
    this.receipt.productGroup = type;
    this.ratedPriceRequest.ProductGroup = type;
    // this.utilites.getCountries((res) => {
      var countries = JSON.parse(JSON.stringify(this.allCountriesData));
      this.countries = countries;
      if (this.receipt.productGroup == 'EXP') {
        countries.splice(countries.indexOf(countries.filter(x => x.value == this.branchCountryCode)[0]), 1);
        this.countries = countries;
      }
      else {
        this.countryCode = JSON.parse(sessionStorage.getItem('company')).BranchCompanyCountryCode;
        this.receipt.country = this.countries.filter(x => x.value == this.countryCode)[0];
        this.countries = this.countries.filter(x => x.value == this.countryCode);
        this.onCountrySelect(this.receipt.country);
        this.enableChangeForProductGroup();
      }
    // }, (err) => { });

    if (this.receipt.productGroup == 'DOM') {
      this.countryCode = JSON.parse(sessionStorage.getItem('company')).BranchCompanyCountryCode;
      this.receipt.productType = null;
      this.showProductType = false;
      this.receipt.city = null;
      this.receipt.state = null;
      this.receipt.postalCode = null;
      this.receiptService.getProductTypes((res) => {
        this.productTypes = res;
      }, () => { }, this.receipt.productGroup, { origin: this.branch, destination: this.branch })
    }
    else if (this.receipt.productGroup == 'EXP') {
      this.receipt.city = null;
    }
    // new resolve address on product group
    var branchDetails = JSON.parse(sessionStorage.getItem("branch")).branch;
    var companyDetails = JSON.parse(sessionStorage.getItem("company"));
    var requestToResolveAddress = {
      ProductGroup: this.receipt.productGroup,
      ProductType: this.receipt.productGroup == 'EXP' ? 'PDX' : 'OND',
      ServiceType: this.receipt.mode == 'Outbound' ? 'DLV' : 'PKUP',
      address: {
        City: branchDetails.BranchCity,
        State: branchDetails.BranchState,
        ZipCode: branchDetails.BranchPostCode,
        CountryCode: companyDetails.BranchCompanyCountryCode
      }
    }

    this.utilites.resolveAddress(requestToResolveAddress, null,
      (err) => {
        this.invalidResolve = true
        this.invalidCountryMsg = err.Message
      }).subscribe(
        (x) => {
          this.ratedPriceRequest.OriginAddress = x.Address;
          this.destination = x.Address.Entity
          this.DestinationAddress = x.Address

          this.receiptService.getProductTypes(
            (res) => {
              this.productTypes = res;
              this.productTypes = this.productTypes.filter(x => x.Code != "CAC");
              this.dupShipmentService.setData({getProductTypes: true});
            },
            (err) => {

            }, this.receipt.productGroup, { origin: this.branch, destination: this.destination })
        });

  this.receiptService.getShipperTypes((res)=>{
            console.log(res.object);
            this.shipperTypes = res.object.shipperTypeLookupDTOs;
            this.shipperNationalities = res.object.shipperNationalities;
            console.log(`this.shipperTypes = ${this.shipperTypes}`)
        });

      

  }

  selectedCountryType:any 
  onCountrySelect(type) {
    this.selectedCountryType = type;
    this.cities = [];
    this.hasState = false;
    this.receipt.country = type;
    this.enableSelectPostalCode(true);
    if (this.receipt.country) {
      this.hasState = this.receipt.country.hasStates != undefined ? this.receipt.country.hasStates : false;
      this.postCodeRequired = this.receipt.country.postCodeRequired != undefined ? this.receipt.country.postCodeRequired : false;
      if (!this.postCodeRequired)
        this.showCity = true;
      else
        this.showCity = false;
      this.utilites.getCityNameByStateAndCountryCode(this.receipt.country.value, "N/A", (res) => {
        this.cities = res;
        this.dupShipmentService.setData({getCountry: true});
      }, () => {})
      this.countryCode = this.receipt.country.value;
    }
    this.scrollPlease()
  }



    onStateSelect(type) {
    this.receipt.state = type;
    this.enableSelectCity(true);
    this.utilites.getCityNameByStateAndCountryCode(this.receipt.country.value, this.receipt.state.key, (res) => {
      this.cities = res;
      this.scrollPlease()
    }, () => {
    })
  }
  destination: string = this.branch;
  invalidCity = false;
  invalidCityMessage: string = '';
  onCityChange() {
    this.invalidCity = false;
    this.invalidCityMessage = '';
  }
  onCitySelect(type) {
    this.receipt.city = type;
    this.enableSelectProductType(true);
    if (this.hasState && this.postCodeRequired) {
      this.utilites.getStatesByCountryCode(this.receipt.state.value, this.receipt.country.value, (res) => {
        this.states = res;
      }, (err) => { })
      var autoSelectStateObj = { key: type.value, value: type.key };
      if (!this.hasState)
        this.onStateSelect(autoSelectStateObj);
      else {
        this.onStateSelect({ key: this.receipt.state.key, value: this.receipt.state.value });
      }
    }

    var requestToResolveAddress = {
      ProductGroup: this.receipt.productGroup,
      ProductType: this.receipt.productGroup == 'EXP' ? 'PDX' : 'OND',
      ServiceType: this.receipt.mode == 'Outbound' ? 'DLV' : 'PKUP',
      address: {
        City: this.receipt.city == null ? null : this.receipt.city.key,
        State: this.receipt.state == null ? null : this.receipt.state.value,
        // cocate number 3 temporarly unti meachiel return correct zipCodes
        ZipCode: this.receipt.postalCode == null ? null : this.receipt.postalCode,
        CountryCode: this.receipt.country.value
      }
    }

    this.utilites.resolveAddress(requestToResolveAddress, (res) => {
    }, (err) => {
      this.invalidCity = true
      this.invalidCityMessage = err.Message
      this.showCity = false;
      this.receipt.city = null;
      this.receipt.State = null;

    }).subscribe((x) => {
      var city = { key: x.Address.City, value: '' }
      var state = { key: x.Address.StateName, value: '' }
      this.utilites.getCityNameByStateAndCountryCode(this.receipt.country.value, state.key, (res) => {
        this.cities = res;
      }, () => { })
      this.DestinationAddress = x.Address
      this.ratedPriceRequest.DestinationAddress = x.Address;
      this.destination = x.Address.Entity
      this.receipt.city = city
      this.receipt.state = state
      this.receiptService.getProductTypes((res) => {
        this.productTypes = res;
        if (this.receipt.productGroup == "EXP") {
          this.productTypes = this.productTypes.filter(x => x.Code != "CAC")
        }
      }, () => { }, this.receipt.productGroup, { origin: this.branch, destination: this.destination })

      this.dupShipmentService.setData({isCitySelect: true});
    }, (err) => {
    })


  }
  DestinationAddress
  onPostalCodeSelect(type) {
    this.receipt.postalCode = type.postelCode;
    var state = { key: type.StateName, value: type.StateName };
    this.receipt.state = state.value;
    this.onStateSelect(state);
    var city = { key: type.CityName, value: type.CityName };
    this.receipt.city = city.value;
    this.onCitySelect(city);
    this.enableSelectStates(true);
    this.showShipper = false;
    // var s = this.DestinationAddress;
    this.scrollPlease()
  }
  additionalChargesEditRequest = false;
  onEditRequest(isEditable) {
    this.isReceiptAdditionalChargesNeeded = false;
    this.additionalChargesEditRequest = isEditable;
  }
  onProductTypeSelect(type) {
    this.enableSelectShipper(true);
    this.receipt.productType = type;
    this.ratedPriceRequest.ProductType = type.Code;
    this.currentUserId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    if (this.currentUserId) {
      this.userContext.getRow("GET_USER", this.currentUserId, (res) => {
        this.userAccounts = res.Accounts;
        console.log(`Accounts = ${this.userAccounts}`)
        console.log(`Types = ${this.shipperTypes}`)
        this.dupShipmentService.setData({isSelectProductCall: true});
        this.scrollPlease()
      }, (err) => { })
    }
    console.log("Product Group : ", this.receipt.productGroup);
    if(this.receipt.productGroup == 'EXP'){
  this.receiptService.getShipperTypes((res)=>{
            console.log(res.object);
            this.shipperTypes = res.object.shipperTypeLookupDTOs;
            this.shipperNationalities = res.object.shipperNationalities;
            console.log(`this.shipperTypes = ${this.shipperTypes}`)
        });
}else{
   this.shipperTypes = [];
}
  }
  scrollPlease() {
    // setTimeout(() => {
    //   this._scrollToService
    //     .scrollTo({
    //       offset: 200,
    //       target: 'theEnd',
    //       duration: 650,
    //       easing: 'easeOutElastic',
    //     })
    //     .subscribe(
    //       value => { },
    //       err => console.error(err) // Error is caught and logged instead of thrown
    //     );
    // }, 300)
  }
  pickUpBranches: any[]

  onShipperSelect(type) {
    this.enableSelectConsigneeDetails(true);
    this.receipt.shipper = type.shipper;
    this.ratedPriceRequest.Account = type.account;
    if (this.receipt.productType.Code.toLowerCase() == "cac") {
      this.locationService.getPickupBranches(this.destination, (res) => {
        this.pickUpBranches = res.Results
      }, (err) => {

      })
    }
    this.scrollPlease()
  }

  onConsigneeDetails(type) {
    console.log('consignee Details ', type);
    
    var re = this.receipt;

    this.enableSelectServices(true);
    this.receipt.consigneeDetails = type;
    this.receiptService.getServicesType((res) => {
      this.services = res;
    }, (err) => {
    }, this.receipt.productGroup, { origin: this.branch, destination: this.destination })
    this.utilites.getCurrencies((res) => {
      this.currenceis = res;
      this.scrollPlease()
    }, (err) => { });
  }
  updatePostelCode(type) {
    this.receipt.postalCode = type.postelCode;
    var state = { key: type.StateName, value: type.StateName };
    this.receipt.state = state.value;
    this.onStateSelect(state);
    var city = { key: type.CityName, value: type.CityName };
    this.receipt.city = city.value;
    this.onCitySelect(city);
  }
  onSelectServices(type) {

    this.enableSelectCommodity(true);
    this.receipt.services = type;
    this.receiptService.getCommodities(
      (res) => {
        this.commodities = res;
        this.scrollPlease()
      },
      (err) => { });
    this.branchCurrencyCode = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  }
  commedityEnableChange = true;
  onSelectCommodity(type) {
    this.enableSelectShipmentItems(true);
    this.receipt.commodity = type;
    this.scrollPlease()
  }
  onShipmentItemAdded(shipments) {
    this.receipt.shipmentItems = shipments.shipmentItems
    this.ratedPriceRequest.ChargeableWeight = {
      Value: shipments.ChargeableWeight,
      Unit: 'KG'
    }
    this.commedityEnableChange = false;
    this.additionalChargesEditRequest = true;
    this.scrollPlease()
  }

  onSelectAddtionalCharges(addtionalCharges) {
    this.isReceiptAdditionalChargesNeeded = false;
    this.receipt.additionlCharges = addtionalCharges;
    this.scrollPlease()
    
  }

  enableChange(receiptObj) {
    return this.receipt[receiptObj] == null;
  }
  enableChangeForCountry() {
    if (this.postCodeRequired) {
      return this.enableChange('postalCode');
    }
    else {
      return this.enableChange('city');
    }
  }
  onSelectCategotyObject(category) {
    this.receipt.category = category.Description;
    this.isRequiredShipmentNumberMisc = category.RequiresShipmentNumber;
    this.isRequiredCommentsMisc = category.RequiresComments;
    this.receiptSubTypeIdMisc = category.ReceiptSubTypeId;
    this.enableSelectMiscAWBDetails(true);
  }
  onSelectDetailsObject(detailsObj) {
    this.receipt.AWB = detailsObj;
  }
  onSelectInboundAWB(AWB) {
    this.receipt.AWB = AWB;
    this.shippmentContext = AWB;
    this.tempDisable = false;
  }
  onSelectDropOffAWB(AWB) {
    this.receipt.AWB = AWB;
    this.shippmentContext = AWB;
    this.tempDisable = false;
  }

  damagedItems: boolean = false;
  Status: any[] = [];

handleRTIShipment(event: { hasRTIShipment: boolean; RTIShipments: any[]; damagedItems: boolean; Status: any[] }) {
  console.log('Received RTI shipment from RTI through DropOff:', event);
  this.hasRTIShipment = event.hasRTIShipment;
  this.RTIShipments = event.RTIShipments;
  this.damagedItems = event.damagedItems;
  this.Status = event.Status;
  console.log('Updated Status:', this.Status);
  
}

//adding select packaging
onSelectPackagingAWB(data:any){
    this.showPackaging = true;
    this.tempDisable = false;
    this.selectedSize = data;
  }
  //adding select packaging price
  handleSelectedPackaging(packaging: string) {
    this.packagingPrice = packaging;
  }
  
  enableChangeMode() {
    if (this.receipt.mode == null)
      return false;
    else if (this.receipt.mode == 'Outbound') {
      return this.enableChange('productGroup');
    }
    else if (this.receipt.mode == 'Inbound') {
      return true;
    }
    else if (this.receipt.mode == 'DropOff') {
      return true;
    }
    else if (this.receipt.mode == 'Packaging') {
      return true;
    }
    else if (this.receipt.mode == 'Misc') {
      return this.enableChange('category')
    }
  }
  enableChangeForcityIftherePostel() {
    if (this.postCodeRequired) {
      return this.enableChange('postalCode');
    }
    else {
      return this.enableChange('productType');
    }
  }
  enableChangeForProductGroup() {
    if (this.receipt.productGroup == 'DOM') {
      if (this.receipt.country != null)
        return this.enableChange('country');
      else
        return this.enableChange('productType');
    }
    else {
      return this.enableChange('country');
    }
  }
  enableChangeCity() {
    if (this.hasState) {
      return this.enableChange('state')
    }
    else
      return this.enableChange('productType')
  }
  showState() {
    if (this.hasState && this.receipt.city != null) {
      return true;
    }
    else if (this.hasState && !this.postCodeRequired) {
      return this.receipt.city != null;
    }
    else if (!this.hasState) {
      return false;
    }
  }
  showTheCity() {
    if (this.postCodeRequired)
      return this.receipt.postalCode != null;
    else
      return this.receipt.country != null;
  }
  showProdutType() {
    if (this.receipt.productGroup == 'EXP') {
      if (!this.hasState)
        return this.receipt.city != null;
      else
        return this.receipt.state != null;
    }
    else if (this.receipt.productGroup == 'DOM') {
      return this.receipt.productGroup != null;
    }
  }
  enableSelectProductGroup(show) {
    this.showProductGroup = show;
  }
  enableSelectInboundAWB(show) {
    this.showInboundAWB = show;
  }
    enableSelectPackaging(show){
      this.showPackaging = show;
    }
  enableSelectCategory(show) {
    if (!show) {
      this.receipt.mode = null;
    }
    this.showCategory = show;
  }
  enableSelectMiscAWBDetails(show) {
    if (!show) {
      this.receipt.category = null;
      this.receipt.AWB = null;
    }
    this.MiscAWBDetails = show;
  }
  enableSelectProductType(show) {
    if (!show) {
      if (this.receipt.productGroup == 'EXP') {
        if (this.hasState)
          this.receipt.state = null
        else
          this.receipt.city = null;
      }
      else if (this.receipt.productGroup == 'DOM') {
        if (this.postCodeRequired) {
          if (this.hasState)
            this.receipt.state = null
          else
            this.receipt.city = null;
        }
        else {
          this.receipt.productGroup = null;
        }
      }
    }
    this.showProductType = show;
    if (this.showProductType) {

      this.showProductTypeFun();
    }
  }
  enableSelectShipper(show) {
    if (!show) {
      this.receipt.productType = null;
    }
    this.showShipper = show;
  }
  enableSelectConsigneeDetails(show) {
    if (!show) {
      this.receipt.shipper = null;
    }
    this.showConsigneeDetails = show;
  }
  enableSelectServices(show) {
    if (!show) {
      this.receipt.consigneeDetails = null;
    }
    this.showServices = show;
  }
  enableSelectCommodity(show) {
    if (!show) {
      this.receipt.services = null;
    }
    this.showCommodity = show;
  }
  enableSelectShipmentItems(show) {
    if (!show) {
      this.receipt.shipmentItems = null;
      this.receipt.commodity = null;
    }
    this.showShipmentItems = show;
  }
  enableSelectCountry(show) {
    if (!show) {
      this.receipt.productGroup = null;
    }
    this.showCountry = show;
  }
  enableSelectPostalCode(show) {
    if (!show) {
      this.receipt.country = null;
      this.postCodeRequired = false;
    }
    this.showPostalCode = show;
  }
  enableSelectStates(show) {

    if (!show) {
      if (this.postCodeRequired) {
        this.receipt.postalCode = null;
      }
      else {
        this.receipt.city = null;
      }
      this.invalidCity = false;
    }
    this.showCity = show;
  }
  enableSelectCity(show) {
    if (!show) {
      this.receipt.city = null;
    }
    this.showTheState = show;
  }

  showProductTypeFun() {
    if (this.receipt.productGroup == "EXP") {
      if (!this.showProductType) {
        return false;
      }
      if (this.receipt.city != null) {
        return true;
      }
      else {
        return false;
      }
    }

    else if (this.receipt.productGroup == "DOM") {
      if (this.receipt.country != null && this.receipt.city != null)
        return true;
      else
        return false;
    }

  }
  addShipmentAttachment(attachment) {
    this.receipt.commercialInvoice = attachment;
  }
  onGenerateInvoiceClick(data) {
    this.generateInvoiceData = data;
  }

  getAccountsForPackaging(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.currentUserId) {
        this.userContext.getRow("GET_USER", this.currentUserId, (res) => {
          this.userAccounts = res.Accounts;
          this.ratedPriceRequest.Account = this.userAccounts;
          this.dupShipmentService.setData({ isSelectProductCall: true });
          this.scrollPlease();
          resolve(res.Accounts);
        }, (err) => {
          reject(err);
        });
      } else {
        reject('No current user ID');
      }
    });
  }

 processRateCalculation(ratedPriceRequest: any): any {
  try {
    const res =  this.getAccountsForPackaging();
    ratedPriceRequest.Account = res[0];

    const rateRes =  new Promise((resolve, reject) => {
      this.receiptService.calculateRate(ratedPriceRequest, resolve, reject);
    });
    var TotalAmount = rateRes as any;
    this.ratedPriceRequest = TotalAmount;
    console.log("Rate Response:", rateRes);
    

    if (this.generateInvoiceData.invoiceNumber?.trim()) {
      try {
        const comRes =  new Promise((resolve, reject) => {
          this.receiptService.generateCommercialInvoice(
            this.getCommercialInvoicePayload(this.ratedPriceRequest.WaybillNumber),
            resolve,
            reject
          );
        });

        
      } catch (error) {
        console.error("Error generating commercial invoice:", error);
      }
    }

    this.updateAfterCalculate(rateRes);
  } catch (error) {
    this.tempDisable = false;
    console.error("Error in processRateCalculation:", error);
  }
}


  addToReceipt() {
    let setting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND);
    if (setting != undefined) {
      this.isMultiCurrenciesForInbound = setting.Value == 'True';
    }

    this.tempDisable = true;
    if (this.receipt.mode == 'Outbound') {
      this.ratedPriceRequest.PaymentType = 'P';
      var cashOnDelivery = 0;
      var currancyCOD = this.branchCurrencyCode
      var currancyShield = this.branchCurrencyCode
      var insurance = 0;
      var services = "";
      this.receipt.services.forEach((item, index) => {
        var comma = this.receipt.services.length == index ? "" : ",";
        services += item.Code + comma;
      })
      this.services.forEach((item) => {
console.log('this is the Item: ', item);

        if (item.Code == 'CODS' || item.Code == 'CODR') {
          var _item = item as any;
          currancyCOD = item.currancy
          cashOnDelivery = _item.value;
        }
        if (item.Code == 'SHIELD') {
          var _item = item as any;
          currancyShield = item.currancy
          insurance = _item.value;
        }
      })
      var additionalChargesTotal = 0;
      var additionalCharges = this.receipt.additionlCharges as any[];
      if (additionalCharges != null) {
        additionalCharges.forEach((x) => {
          additionalChargesTotal += parseFloat(x.chargeValue)
        })
      }
      var additionalCharges = this.receipt.additionlCharges as any[];
      this.OutboundAdditionalCharges = [];
      if (additionalCharges) {
        additionalCharges.forEach(x => {
          this.OutboundAdditionalCharges.push(
            {
              "AdditionalCharge": {
                "Id": x.chargeType,
                "Description": x.chargeTypeDescription
              },
              "Amount": x.chargeValue,
              "Comments": x.chargeDescription
            })
        });
      }
      this.ratedPriceRequest.CashOnDelivery = {
        "Value": cashOnDelivery,
        "Code": currancyCOD == undefined ? this.branchCurrencyCode : currancyCOD
      }
      this.ratedPriceRequest.Insurance = {
        "Value": insurance,
        "Code": currancyShield == undefined ? this.branchCurrencyCode : currancyShield
      };
      this.ratedPriceRequest.Services = services;
      this.ratedPriceRequest.Customs = {
        "Value": this.receipt.commodity.goodsValue,
        "Code": this.receipt.commodity.branchCurrencyCode
      };

      this.ratedPriceRequest.AdditionalCharges = {
        "Value": additionalChargesTotal,
        "Code": this.branchCurrencyCode
      }
      if (this.receipt.consigneeDetails.shortCodeActive == true) {
        this.ratedPriceRequest.ConsigneeAddress = this.receipt.consigneeDetails.addressLine;
        this.ratedPriceRequest.DestinationAddress.City = this.receipt.consigneeDetails.destinationCity;
        this.ratedPriceRequest.shortCodeActive = this.receipt.consigneeDetails.shortCodeActive;
        this.receipt.shortCodeActive = this.receipt.consigneeDetails.shortCodeActive;
        this.ratedPriceRequest.shortCode = this.receipt.consigneeDetails.shortCode;
        this.receipt.Latitude = this.receipt.consigneeDetails.latitude;
        this.receipt.Longitude = this.receipt.consigneeDetails.longitude;
      }
      else if (this.receipt.productGroup == 'EXP') {
        this.ratedPriceRequest.DestinationAddress = this.DestinationAddress;
      }

      this.receiptService.getArrowable(this.receipt.productGroup).subscribe((res) => {
        this.ratedPriceRequest.WaybillNumber = res;
        this.receiptService.calculateRate(this.ratedPriceRequest, (res) => {
          if (this.generateInvoiceData.invoiceNumber != null && this.generateInvoiceData.invoiceNumber.trim() != '') {
            this.receiptService.generateCommercialInvoice(this.getCommercialInvoicePayload(this.ratedPriceRequest.WaybillNumber), (comRes) => {
              if (comRes && comRes.Base64) {
                this.addShipmentAttachment(comRes.Base64);
                this.updateAfterCalculate(res);
              }
            }, () => { })
          } else {
            this.updateAfterCalculate(res);
          }
        }, (err) => {
          this.tempDisable = false;
        })

      }, (err) => { })
      
    }
    else if (this.receipt.mode == 'Inbound') {
      var smartShipments = this.receipt.AWB.filter(x => x.Shipment.validated == false) as any[];

      if (smartShipments.length > 0) {
        this.toaster.warning(`${this.translate.instant('pages.createReceiptPage.validateSmartShipment')}`)
        this.tempDisable = false;
        return;
      }


      var listOfInboundShipment = this.receipt.AWB as any[];

      if (this.isMultiCurrenciesForInbound == false) {
        if (this.shippments.length != 0) {
          var c = this.shippments.filter(x => x.Number == this.receipt.AWB[0].Number)
          if (c.length > 0) {
            this.toaster.error(`${this.translate.instant('pages.createReceiptPage.shipmentExsist', {
              shipmentNumber: this.receipt.AWB[0].Number
            })}`);
            return false;
          }
        }
      } else {
        if (this.shippments.length != 0) {
          let isError = false;
          this.receipt.AWB.forEach((item: any) => {
            let currentCurrency = this.getCurrency(item.Shipment);
            var c = this.shippments.filter(x => x.Number == item.Number && (x ? currentCurrency == this.getCurrency(x) : true));
            if (c.length > 0) {
              isError = true;
              this.toaster.error(`${this.translate.instant('pages.createReceiptPage.shipmentExsistWithCurrency', {
                itemNumber: item.Number,
                currentCurrency: currentCurrency
              })}`);
              return false;
            }
          })

          if (isError) {
            return false;
          }
        }
      }

      var OTPShipments = this.receipt.AWB.filter(x => x.Shipment.OTPValidated == false && x.Shipment.OTPShipmentProperty != null) as any[];
      if (OTPShipments.length > 0) {
        this.toaster.warning(`${this.translate.instant('pages.createReceiptPage.validateShipmentWithOtp')}`)
        this.tempDisable = false;
        return;
      }

      listOfInboundShipment.forEach((x) => {
        x.Shipment.mode = 'Inbound';
        x.Shipment.discount = { isLocked: true };
        this.shippments.push(x.Shipment);
        this.updateShipmentsByCurrency(x.Shipment.Number, this.getCurrency(x.Shipment));
      })

      listOfInboundShipment = [];
      this.isReceiptLocked = false;

      this.receipt = {} as receipt
      this.ratedPriceRequest = {};
      this.change = true;
      this.tempDisable = false;
    }
    else if (this.receipt.mode == 'Misc') {
      if (this.receipt.category == 'SNS Subscription') {
        this.receipt.AWB.shipments = [{
          Shipment: {
            amount: 0,
            comment: '',
            mode: 'Misc',
            discount: { isLocked: true },
            type: this.receipt.category

          }
        }]
        var listOfInboundShipment = this.receipt.AWB.shipments as any[];

        listOfInboundShipment.forEach((x) => {
          x.Shipment.amount = this.receipt.AWB.amount,
            x.Shipment.comment = this.receipt.AWB.comment,
            x.Shipment.mode = 'Misc';
          x.Shipment.discount = { isLocked: true };
          this.shippments.push(x.Shipment);
        })
        listOfInboundShipment = [];
        this.isReceiptLocked = false;
        this.receipt = {} as receipt
        this.ratedPriceRequest = {};
        this.change = true;
      }
      else {
        var listOfInboundShipment = this.receipt.AWB.shipments as any[];
        listOfInboundShipment.forEach((x) => {
          x.Shipment.amount = this.receipt.AWB.amount,
            x.Shipment.comment = this.receipt.AWB.comment,
            x.Shipment.mode = 'Misc';
          x.Shipment.discount = { isLocked: true };
          this.shippments.push(x.Shipment);
        })
        listOfInboundShipment = [];
        this.isReceiptLocked = false;
        this.receipt = {} as receipt
        this.ratedPriceRequest = {};
        this.change = true;
        this.tempDisable = false;
      }
    } else if (this.receipt.mode == 'DropOff' && this.hasRTIShipment == false) {
      var listOfDropOffShipment = this.receipt.AWB as any[];

      listOfDropOffShipment.forEach((x) => {
        x.mode = 'DropOff';
        this.shippments.push(x);
        this.updateShipmentsByCurrency(x.Number, x?.NewCost?.Code);
      })

      this.isReceiptLocked = false;
      this.receipt = {} as receipt
      this.ratedPriceRequest = {};
      this.change = true;
      this.tempDisable = false;
    }
    else if (this.receipt.mode == 'Packaging') {
      this.showCountry = false;
      this.receipt.productGroup = 'DOM';
      var DestinationCode = JSON.parse(sessionStorage.getItem('branch')).branch.BranchCompanyCode;
      var branchDetails = JSON.parse(sessionStorage.getItem("branch")).branch.BranchDisplayName;
      var CurrencyCode = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
      var CityCode = JSON.parse(sessionStorage.getItem('branch')).branch.BranchCity;
      var CountryCode = JSON.parse(sessionStorage.getItem('company')).BranchCompanyCountryCode;
      var branchWeightUnit = JSON.parse(sessionStorage.getItem("company")).BranchCompanyDefaultWeightUnit;
      this.currentUserId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
      var zipCode = JSON.parse(sessionStorage.getItem("branch")).branch.BranchPostCode;

      var packagingObj = {
        mode: 'Packaging',
        "SubType": null,
        Amount: this.packagingPrice,
        Comments: 'Packaging ' + this.receipt.AWB,
        DiscountAmount: 0,
        DiscountValue: null,
        DiscountValueBy: null,
        DiscountComments: '',
        IsCancelled: false,
        Type: {
          Description: "Packaging",
          ReceiptTypeId: 5
        },
        Shipment: {
          Number: '',
          ProductType: 'OND',
          BusinessType: '',
          CCCollectionID: 0,
          CODCollectionID: 0,
          CollectDocumentNumber: '',
          ConsigneeAddress: DestinationCode,
          ConsigneeName: branchDetails,
          CustomsDocumentNumber: '',
          DestinationAddress: {
            City: CityCode,
            CountryCode: CountryCode,
            Entity: DestinationCode,
            LocatioCode: DestinationCode,
            StateName: '',
            ZipCode: '',
          },
          OriginAddress: {
            City: CityCode,
            CountryCode: CountryCode,
            Entity: DestinationCode,
            LocatioCode: DestinationCode,
            StateName: '',
            ZipCode: zipCode,
          },
          ProductGroup: 'DOM',
          Price: this.packagingPrice,
          RatedPrice: {
            Value: this.packagingPrice,
            Code: CurrencyCode
          },
          ShipperAccountTaxRate: 0,
          GrandTotal: {
            Value: this.packagingPrice,
            Code: CurrencyCode
          },
          TaxAmount: {
            Value: 0,
            Code: CurrencyCode
          },
          ShipmentId: 0,
          ShipperAddress: DestinationCode,
          ChargeableWeight: {
            Value: 0.00,
            Unit: branchWeightUnit,
          },
          WeightFactor: 0,
          discount: { isLocked: true },
        },
      }
      // create AWB Number
      this.receiptService.getArrowable(this.receipt.productGroup).subscribe((res) => {
        this.ratedPriceRequest = {
          WaybillNumber: res,
          DestinationAddress: packagingObj.Shipment.DestinationAddress,
          ProductGroup: 'DOM',
          OriginAddress: packagingObj.Shipment.OriginAddress,
          ChargeableWeight: packagingObj.Shipment.ChargeableWeight,
          PaymentType: 'P',
          ProductType: 'OND',
          ShipmentMode: 'Packaging',
          PackagingPrice: packagingObj.Shipment.Price
        };

        this.ratedPriceRequest.DestinationAddress.LocatioCode = CurrencyCode;
        this.ratedPriceRequest.OriginAddress.LocatioCode = CurrencyCode;
        this.ratedPriceRequest.ChargeableWeight.value = 0.1;

        this.userContext.getRow("GET_USER", this.currentUserId, (userRes) => {
          this.userAccounts = userRes.Accounts[0];
          this.ratedPriceRequest.Account = this.userAccounts;

          this.receiptService.calculateRate(this.ratedPriceRequest, (rateRes) => {
            
            console.log('this is rateRes', rateRes);
            packagingObj.Shipment.Price = rateRes.TotalAmount;
            packagingObj.Shipment.GrandTotal.Value = rateRes.TotalAmount;
            packagingObj.Shipment.TaxAmount.Value = rateRes.TaxAmount;
            packagingObj.Shipment.ShipperAccountTaxRate = rateRes.TaxRate;
            this.receipt.AWB = res;
            this.receipt.mode = 'Packaging';
            packagingObj.Shipment.Number = this.receipt.AWB;
            console.log('this is packagingObj', packagingObj);
            this.shippments.push(packagingObj);
            this.updateShipmentsByCurrency(packagingObj.Shipment.Number, CurrencyCode);
            this.isReceiptLocked = false;
            this.receipt = {} as receipt;
            this.change = true;
            this.tempDisable = false;
            if (this.generateInvoiceData.invoiceNumber?.trim()) {
              this.receiptService.generateCommercialInvoice(
                this.getCommercialInvoicePayload(this.ratedPriceRequest.WaybillNumber),
                (comRes) => {
                  if (comRes?.Base64) {
                    this.addShipmentAttachment(comRes.Base64);
                    this.updateAfterCalculate(rateRes);
                  }
                }
                , () => { });
            } else {
              this.updateAfterCalculate(rateRes);
            }
          }, (rateErr) => {
            this.tempDisable = false;
          });
        }, (userErr) => { });



      });


    }
    else if (this.receipt.mode == 'DropOff' && this.hasRTIShipment == true) {
      var listOfDropOffShipment = this.receipt.AWB as any[];

      listOfDropOffShipment.forEach((x) => {
        x.mode = 'DropOff';
        //handle RTI shipment case in creat-edit-receipt
        x.hasRTIShipment = this.hasRTIShipment;
        x.damagedItems = this.damagedItems;
        x.Status = this.Status;
        this.shippments.push(x);
        this.updateShipmentsByCurrency(x.Number, x?.NewCost?.Code);
      })

      this.isReceiptLocked = false;
      this.receipt = {} as receipt
      this.ratedPriceRequest = {};
      this.change = true;
      this.tempDisable = false;
      

    }
}

openRTIPopup() {
  this.showDropOffAWB = true;
  this.receipt = {
    mode: 'DropOff',
    AWB: []
  };
  this.change = true;
}

  updateAfterCalculate(res) {
    this.tempDisable = false;
    this.ratedPriceRequest.ratedPrice = res;
    this.receipt.ratedPrice = this.ratedPriceRequest;
    this.receipt.OutboundAdditionalCharges = this.OutboundAdditionalCharges;
    this.shippments.push(this.receipt);
    this.updateShipmentsByCurrency(this.ratedPriceRequest.WaybillNumber, this.ratedPriceRequest.ratedPrice.CurrencyCode);

    console.log('this shippment: ', this.shippments);
    
    this.receipt.discount = { isLocked: true };
    this.isReceiptLocked = false;
    this.receipt = {} as receipt
    this.ratedPriceRequest = {};

    this.change = true;
    this.tempDisable = false;
    this.generateInvoiceData = {};
  }
  getCurrency(shipment) {
    let branchCurrencyCode = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
    if (this.checkCurrency(shipment.CashOnDelivery.Code) && shipment.CashOnDelivery.Value != 0) {
      return shipment.CashOnDelivery.Code;
    } else  if (this.checkCurrency(shipment.Customs.Code) && shipment.Customs.Value != 0) {
      return shipment.Customs.Code;
    } else if (this.checkCurrency(shipment.RatedPrice.Code) && shipment.RatedPrice.Value != 0) {
      return shipment.RatedPrice.Code;
    }

    return branchCurrencyCode;
  }
  checkCurrency(currency: string) {
    return currency != null && currency.trim() != ''
  }
  addToReceiptValidationMessage = '';
  onShipmentItemsChangeRequest(request) {
    this.commedityEnableChange = true;
    this.receipt.additionlCharges = null;
  }

  addToReceiptHandler() {
    if(this.selectedSize == true && this.receipt.mode == 'Packaging')
      return true;
    if (this.receipt.mode == 'Outbound') 
      return this.receipt.shipmentItems != null;
    
    else if (this.receipt.mode == 'Inbound' || this.receipt.mode == 'Misc') 
      return this.receipt.AWB != null;
  }
  onRemoveShipment(event) {
    var awb = event.number;
    var mode = event.type;
    var index = -1;
    if (mode == 'outbound') {
      index = this.shippments.findIndex(function (item, i) {
        return item.ratedPrice && item.ratedPrice.WaybillNumber && item.ratedPrice.WaybillNumber === awb;
      });
      this.removeShipmentsByCurrency(awb, event.code);
      this.shippments.splice(index, 1)
    } else {
      this.shippments = this.shippments.filter((item, i) => {
        return item.Number != awb;
      });
      this.removeShipmentsFromAllCurrency(awb);
    }
  }
  onDiscountShipment(event) {
    var awb = event.number;
    var mode = event.type;
    var currency = event.currency;
    var index = this.shippments.findIndex((item, i) => {
      if (mode.toLowerCase() == 'inbound') {
        return item.Number == awb && this.getCurrency(item) == currency;
      }
      if (mode.toLowerCase() == 'dropoff') {
        return item.Number == awb;
      }

      return item.ratedPrice.WaybillNumber === awb;
    });
    this.shippments[index].discountAmount = event.discount
    this.shippments[index].discountComment = event.comments

    this.shippments[index].discountValue = event.discountValue
    this.shippments[index].discountValueBy = event.discountValueBy

  }
  onDuplicateShipment(event) {
    this.dupShipmentService.setData({});
    // this.isduplicateShipmentCall = true;
    this.receipt = {} as receipt
    this.ratedPriceRequest = {};
    this.isReceiptLocked = true;
    this.resetAdditionalCharges = true;
    this.change = true;

    const pGroup = event.data.Shipment.ProductGroup;
    const pType = event.data.Shipment.ProductType;
    const dCountryCode = event.data.Shipment.DestinationAddress.CountryCode;
    const dZipCode = event.data.Shipment.DestinationAddress.ZipCode;
    const dCity = event.data.Shipment.DestinationAddress.City;
    const dStateName = event.data.Shipment.DestinationAddress.StateName;
    let shipperInfo = { 
      name: event.data?.Shipment?.ShipperName ? event.data?.Shipment?.ShipperName : '',
      mobile: event.data?.Shipment?.ShipperMobile ? event.data?.Shipment?.ShipperMobile : '',
      addressLine: event.data?.Shipment?.ShipperAddress ? event.data?.Shipment?.ShipperAddress : '',
      shippmentReference: event.data?.Shipment?.Reference ? event.data?.Shipment?.Reference : '',
      email: event.data?.Shipment?.ShipperEmail ? event.data?.Shipment?.ShipperEmail : '',
      accountNumber: event.data?.Shipment?.ShipperAccountNumber ? event.data?.Shipment?.ShipperAccountNumber : '',
      shipperType: this.shipperTypes
    }

    if(pGroup == "DOM"){
      this.postCodeRequired = false;
    }

    this.receiptModeEle.selectMode("Outbound",true);
    if (this.receiptProductGroupEle) {
      this.receiptProductGroupEle.selectProductGroup(pGroup,true);
    }

    this.duplicateShipmentSubscription =  this.dupShipmentService.shipmentObservable.subscribe((data) => {
      if(data){
        if(data.getProductTypes){
          const country = this.allCountriesData.filter(x => x.value == dCountryCode)[0];
          this.onCountrySelect(country);
          // if (pGroup == 'EXP') {
          // }
        }
        if(data.getCountry){
          if (this.postCodeRequired) {
            let apiText = this.postalDataService.genratePostalCodeKey(dCountryCode,dZipCode);
            let postalData = this.postalDataService.getPostalCodes(apiText);
            if(postalData){
              if (postalData && Array.isArray(postalData) && postalData.length > 0) {
                this.postalCode.changeByClick(postalData[0],true);
              }
            } else{
              this.utilites.getPostCodes(dCountryCode, dZipCode, (res) => {
                let resData = res.Results;
                if (resData && Array.isArray(resData) && resData.length > 0) {
                  this.postalCode.changeByClick(resData[0],true);
                }
              }, (err) => { })
            }
          } else {
            this.onCitySelect({
              key: dCity,
              value: dStateName,
            });
          }
        }
        if(data.isCitySelect){
          this.setProductTypeOnDuplicate(pType);
        }
        if(data.isSelectProductCall){
          this.showShipper = true;
          this.shipperReceipt.setShipperInfo(shipperInfo,true);
          this.duplicateShipmentSubscription.unsubscribe();
        }
      }
    })
  }
  setProductTypeOnDuplicate(pType) {
    if (this.productTypeEle) {
      const selectedPType = this.productTypes.find((x) => x.Code == pType);
      if (selectedPType)
        this.productTypeEle.selectProductType(selectedPType);
    }
  }
  onAddShippmentRequest(type) {
    if (type == true) {
      this.receipt = {} as receipt
      this.ratedPriceRequest = {};
      this.isReceiptLocked = true;
      this.change = true;
    }
    this.resetAdditionalCharges = true;
  }
  onClose() {
    this.isReceiptLocked = true;
  }
  showCommercialInvoice = false;
  onCloseCommercialInvoice() {
    this.showCommercialInvoice = false;
  }
  showGenerateCommercialInvoice = false;
  onCloseGenerateCommercialInvoice() {
    this.showGenerateCommercialInvoice = false;
  }
  onCancelAdditionalCharges(event) {
    this.isReceiptAdditionalChargesNeeded = false;
    this.receipt.additionlCharges = null;
  }

  updateShipmentsByCurrency(AWB: string, tCurrencyCode: string) {
    if (this.shipmentsByCurrency[tCurrencyCode]) {
      if (Array.from(this.shipmentsByCurrency[tCurrencyCode]).find((e: any) => e.shipmentNo === AWB) == undefined) {
        this.shipmentsByCurrency[tCurrencyCode].add({
          type: this.receipt.mode.toLowerCase(),
          shipmentNo: AWB
        });
      }
    } else {
      this.shipmentsByCurrency[tCurrencyCode] = new Set([{
        type: this.receipt.mode.toLowerCase(),
        shipmentNo: AWB
      }]);
    }
    console.log("Updated shipmentsByCurrency:", this.shipmentsByCurrency);
    
  }
  removeShipmentsByCurrency(AWB: string, tCurrencyCode: string) {
    if (this.shipmentsByCurrency[tCurrencyCode]) {
      this.shipmentsByCurrency[tCurrencyCode].forEach(x => x.shipmentNo === AWB ? this.shipmentsByCurrency[tCurrencyCode].delete(x) : x)

      if (this.shipmentsByCurrency[tCurrencyCode].size === 0) {
        delete this.shipmentsByCurrency[tCurrencyCode];
      }
    }
  }
  removeShipmentsFromAllCurrency(AWB: string) {
    Object.keys(this.shipmentsByCurrency).forEach((x) => {
      this.removeShipmentsByCurrency(AWB, x);
    })
  }
  getCommercialInvoicePayload(awb) {
    return {
      "InvoiceNumber": this.generateInvoiceData.invoiceNumber,
      "HAWBNumber": awb,
      "TaxId": this.generateInvoiceData.taxId,
      "InvoiceDate": this.generateInvoiceData.invoiceDate,
      "ReasonForExport": this.generateInvoiceData.reasonForExport,
      "ShipperName": this.receipt.shipper.name,
      "ShipperAddress": this.receipt.shipper.addressLine,
      "ShipperType":this.receipt.shipper.shipperType,
      "ShipperCity": this.branchCity,
      "ShipperCountry": this.branchCompanyCountryName,
      "ShipperTelephone": this.receipt.shipper.mobile,
      "ConsigneeName": this.receipt.consigneeDetails.name,
      "ConsigneeAddress": this.receipt.consigneeDetails.addressLine,
      "ConsigneeCity": this.receipt.city.key,
      "ConsigneeCountry": this.receipt.country.key, 
      "ConsigneeTelephone": this.receipt.consigneeDetails.mobile,
      "ConsigneeAttentionOf": this.receipt.consigneeDetails.attention,
      "InvoiceItems": this.generateInvoiceData.invoiceItems.map((item) => ({
        "Desc": item.desc,
        "Quntity": item.quntity,
        "UnitType": item.unitType,
        "UnitPrice": item.unitPrice,
        "HrmValue": item.hrmValue,
        "Ref": item.ref,
        "Currency": item.currency,
        "MfCountry": item.mfCountry
      }))
    }
  }
  handleCommercial
}
